import Card from "@mui/material/Card";
import RocketPin from "assets/images/apollo-english/rocket-pin.png";

import { useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import MDPinInput from "components/MDPinInput/MDPinInput";

const PinInputCard = (props) => {
  const { isLoading: isLoadingPostVerifyPin } = useSelector(
    (state) => state.mySelf.callPostVerifyPin
  );
  const { isLoading: isLoadingPostResetPin } = useSelector(
    (state) => state.mySelf.callPostResetPin
  );

  const { verifyPin, setVerifyPin, onPinVerification, onResetPin } = props;
  const pinInputRef = useRef(null);

  const onChange = (value) => {
    if (!isLoadingPostVerifyPin && value.length === 4) {
      console.log("[PinInputCard] PIN entered:", value);
      onPinVerification(value);
    }
  };

  const onClickResetPin = (e) => {
    e.preventDefault();
    if (!isLoadingPostResetPin) {
      console.log("[PinInputCard] Reset PIN clicked");
      onResetPin();
    }
  };

  useEffect(() => {
    if (verifyPin.error && pinInputRef.current) {
      setVerifyPin((prevState) => {
        return { ...prevState, resetClicked: false };
      });
      pinInputRef.current.clear();
      console.log("[PinInputCard] Cleared PIN inputs due to error");
    }
  }, [isLoadingPostVerifyPin, verifyPin.error, setVerifyPin]);

  return (
    <Card
      className="pin-input-card-container"
      style={{ backgroundColor: "#CCE7FF" }}
    >
      <img src={RocketPin} alt="RocketPin" />
      <h2>Enter your PIN</h2>
      <div className="pin-input">
        <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
          <MDPinInput
            pinInputRef={pinInputRef}
            length={4}
            initialValue=""
            secret
            secretDelay={500}
            type="numeric"
            inputMode="number"
            onChange={onChange}
            autoSelect={true}
            regexCriteria={/^[0-9]*$/} // Updated to allow only digits
            disabled={isLoadingPostVerifyPin}
          />
        </form>
      </div>
      {verifyPin.error ? (
        verifyPin.resetClicked ? (
          <p className="error">
            Reset instructions have been sent to your email.
          </p>
        ) : (
          <>
            <p className="error">PIN does not match. Please try again.</p>
            <p className="error">You have {verifyPin.attemptsLeft} attempts.</p>
            <p className="error">
              Or don’t remember the PIN? Click{" "}
              <a
                onClick={onClickResetPin}
                style={{ cursor: "pointer", color: "#F5365C" }}
              >
                {isLoadingPostResetPin && <CircularProgress size={12} />}
                here
              </a>{" "}
              to reset.
            </p>
          </>
        )
      ) : (
        <p className="forgot-pin">
          {verifyPin.resetClicked ? (
            "Reset instructions have been sent to your email."
          ) : (
            <>
              Forgot your PIN code? Click{" "}
              <a
                onClick={onClickResetPin}
                style={{ cursor: "pointer", color: "#8392AB" }}
              >
                {isLoadingPostResetPin && <CircularProgress size={12} />}
                here
              </a>{" "}
              to reset.
            </>
          )}
        </p>
      )}
    </Card>
  );
};

export default PinInputCard;
